import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ComponentBase } from '../../core/_infrastructure/classes/componentBase';
import { AuthService } from '../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../core/_infrastructure/classes/handlers/exceptionManager';
import { HttpParams } from '@angular/common/http';
import { VerificarCertificadoService } from './verificar-certificado.service';
import { CertificadoVerificadoViewModel } from './verificar-certificado.types';
import { CustomHttpParamEncoder } from '../../core/_infrastructure/classes/handlers/urlSerializerHandler';

@Component({
    selector: 'app-verificar-certificado',
    templateUrl: './verificar-certificado.component.html',
})
export class VerificarCertificadoComponent extends ComponentBase implements OnInit {
    editMode: boolean = false;
    editTitle: string = 'Nueva';
    resultValidarCF: CertificadoVerificadoViewModel; //ValidarCFViewModel;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private fb: UntypedFormBuilder,

        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private verificarCertificadoService: VerificarCertificadoService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultValidarCF = new CertificadoVerificadoViewModel();
    }

    ngOnInit() {
        this.form = this.fb.group({
            Token: '',
        });

        //Miramos si la llamada al componente se hace desde la URL+Token que proporciona la lectura del código QR del CF
        let token = this.activatedRoute.snapshot.params['token'];

        if (token) {
            this.form.setValue({ Token: token });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        this.removeValidators('Token');
        this.addValidator('Token', Validators.required);

        if (this.isFieldInvalidNoSubmit('Token', 'required')) {
            return;
        }

        this.removeValidators('Token');

        this.Search();

        this.searchingButton = true;
    }

    Search() {
        let params = new HttpParams({ encoder: new CustomHttpParamEncoder() });

        params = params.append('Token', this.form.value.Token);

        this.loading = true;
        this.verificarCertificadoService.verificarcertificado(params).subscribe(result => {
            this.resultValidarCF = result;
            this.loading = false;
        });
    }

    onDownload() {
        //let downloadFileFromSede: DownloadFileFromSedeViewModel = new DownloadFileFromSedeViewModel();

        //downloadFileFromSede.IdSolicitudEx = this.resultValidarCF.IdSolicitudEx;
        //downloadFileFromSede.NumeroCertificado = this.resultValidarCF.;

        let params = new HttpParams();

        params = params.append('idSolicitudEx', this.resultValidarCF.IdSolicitudEx);

        /*this.verificarCertificadoService.downloadFileFromSede(this.resultValidarCF.IdSolicitudEx*/ /*downloadFileFromSede*/ /*)*/
        this.verificarCertificadoService.downloadFileFromSede(this.resultValidarCF.IdSolicitudEx).subscribe(res => {
            this.OpenDownloadedFile(res);
        });
    }

    onCleanButton() {
        this.form.setValue({
            Token: '',
        });

        this.searchingButton = false;
    }
}
